import React from 'react';
import { Modal, Button, Form, Container } from 'react-bootstrap';
import BeatmatchBackendClient from "BeatmatchBackendClient";
import { Formik } from "formik";
import * as yup from 'yup';

const createPlaylistValidationSchema = yup.object().shape(
  {
    name: yup.string().required("Name is required"),
    description: yup.string().optional()
  }
);

const createPlaylist = async (name, description, addPlaylist) => {
  const response = await BeatmatchBackendClient.createPlaylist(name, description);
  const playlistData = {
    Name: response.name,
    description: response.description,
    data: response.tracks.map((track) => ({
      id: track.id,
      artwork: track.artworkLink,
      title: track.title,
      user: {
        name: track.artist
      },
      genre: track.genre,
      mood: track.mood,
      duration: track.duration,
      key: track.key,
      bpm: track.bpm
    }))
  }
  addPlaylist(playlistData)
};

const CreatePlaylistModal = ({ show, onHide, addPlaylist }) => {
  const [error, setError] = React.useState('');
  
  return (
    <Modal size="lg" centered show={show} style={{ color: "black" }} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          Create Playlist
        </Modal.Title>
      </Modal.Header>
      <Container hidden={error === ''} style={{ placeItems: 'center', backgroundColor: 'red', color: 'white'}}>
        <p>{error}</p>
      </Container>
      <Modal.Body>
        <Formik 
          validationSchema={createPlaylistValidationSchema}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              await createPlaylist(values.name, values.description, addPlaylist);
              setError('');
              onHide();
            }
            catch (error) {
              console.error("Error Creating Playlist:", error.message);
              setError(error.message);
            }
            finally {
              setSubmitting(false);
            }
          }}
          initialValues={{
            name: '',
            description: '',
          }}>
            {({ handleSubmit, handleChange, isSubmitting, values, touched, errors }) =>
          (
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formPlaylistName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formPlaylistDescription">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type="textarea"
                  name="description"
                  value={values.description}
                  onChange={handleChange}
                  isInvalid={!!errors.description} />
                <Form.Control.Feedback type="invalid">{errors.description}</Form.Control.Feedback>
              </Form.Group>
              <div className="d-flex justify-content-end">
                <Button variant="primary" type="submit" disabled={isSubmitting}>Create Playlist</Button>
              </div>
            </Form>)}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

export default CreatePlaylistModal;